module.exports = __webpack_public_path__ + "static/media/Rita Cornwell Bedroom Alcoves.874a0798.JPG";